var _topoLayers=null,TOPO_ICC_L0_6,TOPO_MQ_L7_19,TOPO_ICC_L7_10,TOPO_ICC_L11_12,TOPO_ICC_L12_19;
var _topoLayersGeo=null,TOPO_GEO_MQ_L15_18,TOPO_GEO_MQ_L1_6,TOPO_GEO_MON_L0_14,TOPO_GEO_ICC_L8_12,TOPO_GEO_OMBRA_L8_12,TOPO_GEO_ICC_L8_17,TOPO_GEO_ICC_L8_17_TOPONIMS;
var _ortoLayers=null,ORTO_ESRI_L0_19,ORTO_ICC_L0_11,ORTO_ICC_L12_19,ORTO_ICC_L9_12;
var _ortoAurgmentada=null,ORTO_ESRI_L0_19,ORTO_AUGMENTADA_L4_17,ORTO_ICC_L18_20;
var _hibridLayers=null,HIBRID_MQ_L0_18,HIBRID_ICGC_L0_18,HIBRID_ICGC_L13_18;
var _histoMap=null;
var _histoOrtoMap=null;
var _histoOrtoMap46=null;
var _alcadesMap=null;
var _naturalMap=null;
var _divadminMap=null;
var _colorBlankMap=null;
var _hibridTerrainMap=null;
var ESRI_RELLEU_L0_13;
var ICC_RELLEU_L0_14;
var MQ_TOPO_GRIS_L15_19,ICC_TOPO_GRIS_L7_10,ICC_TOPO_GRIS_L11_19,ICC_MON_L0,MQ_TOPO_GRIS_L0_14;
var COLOR_TOPO_ICC_L0_6,COLOR_TOPO_MQ_L7_19,COLOR_TOPO_ICC_L11_19;
var HISTO_ICC_L0_14;
var HISTOOrto_ICC_L0_14;
var HISTOOrto46_ICC_L0_14;
var ALCADAMAPA_ICGC_L0_17;
var DIVADMIN_L0_14;
var DIVADMIN_L14_18;
var DIVADMIN_L14_18_TOPO;
var ORTO_HIBRID_8_18_VECTOR;
var ORTO_HIBRID_L8_17_TOPONIMS;
var TERRAIN_HIBRID_8_18_VECTOR;
var _terrainLayers=null;
var _topoColorLayers=null;
var _grisLayers=null;
var _ombraLayer=null;

var SCOPE_GLOBAL = "global";
var SCOPE_CATALUNYA = "catalunya";
var SCOPE_TOT = "tot"

var SCOPE_VISTA_FORA = "fora";
var SCOPE_VISTA_DINS = "dins";
var SCOPE_VISTA_TOT = "tot";

var subDomains=['a','b','c'];
var subDomainsA=['a','b','c'];

var urlServerTiles="https://{s}tilemaps.icgc.cat";
var urlServerTilesW="https://{s}tilemaps.icgc.cat";

var urlApp=document.location.href;
if((urlApp.indexOf('localhost')!=-1)||(urlApp.indexOf('.local')!=-1)||(urlApp.indexOf('172.20.70.11')!=-1)){
	urlServerTiles="https://{s}tilemaps.icgc.cat";
 	urlServerTilesW="https://{s}tilemaps.icgc.cat";
}

var URL_MQ='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

//no se usan
//hibridInstamaps:urlServerTiles+'/mapfactory/wmts/hibrida/CAT3857/{z}/{x}/{y}.png',
//ombraInstamaps:urlServerTiles+'/mapfactory/wmts/h_ombra/CAT3857/{z}/{x}/{y}.png',
//topo36ICGC:urlServerTiles+'/mapfactory/wmts/cat1936/CAT3857/{z}/{x}/{y}.png',

var mapaUrl = {
	//topoMapMON:urlServerTiles+'/mapfactory/wmts/mon_cat/MON3857/{z}/{x}/{y}.png',
	topoMapOSM:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	topoMapOSM2:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	//topoMapICGC:'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/topo/GRID3857/{z}/{x}/{y}.png',
	topoMapMON:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic/MON3857NW/{z}/{x}/{y}.png',
	//topoMapOSM:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic/MON3857NW/{z}/{x}/{y}.png',


	topoMapICGC:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic/MON3857NW/{z}/{x}/{y}.png',

	//topoMapSuauOSM:urlServerTiles+'/mapfactory/wmts/osm_suau/CAT3857_15/{z}/{x}/{y}.png',
	//topoMapSuauICGC:urlServerTiles+'/mapfactory/wmts/topo_suau/CAT3857/{z}/{x}/{y}.png',

	topoMapSuauOSM:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/simplificat/MON3857NW/{z}/{x}/{y}.png',
	topoMapSuauICGC:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/simplificat/MON3857NW/{z}/{x}/{y}.png',

	ortoEsri:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
	//ortoInstamaps:urlServerTiles+'/mapfactory/wmts/orto_8_12/CAT3857/{z}/{x}/{y}.png',

	ortoInstamaps:'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.png',

	ortoAugmentada:urlServerTilesW+'/mapfactory/wmts/orto_augmentada/CAT3857/{z}/{x}/{y}.jpeg',
	ortoICGC:"https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.png",
	terrainEsri:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}',
	terrainInstamaps:urlServerTiles+'/mapfactory/wmts/relleu/CAT3857/{z}/{x}/{y}.png',
	orto46ICGC:urlServerTiles+'/mapfactory/wmts/orto46/CAT3857/{z}/{x}/{y}.png',
	orto55ICGC:urlServerTiles+'/mapfactory/wmts/orto55/CAT3857/{z}/{x}/{y}.png',

	//topoGrisOSM:urlServerTiles+'/mapfactory/wmts/gris_osm_suau/CAT3857_15/{z}/{x}/{y}.png',
	//topoGrisICGC:urlServerTiles+'/mapfactory/wmts/gris_topo_suau/CAT3857/{z}/{x}/{y}.png',

	topoGrisOSM:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic-gris/MON3857NW/{z}/{x}/{y}.png',
	topoGrisICGC:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic-gris/MON3857NW/{z}/{x}/{y}.png',

	topoNaturalOSM:'http://{s}.tile.thunderforest.com/landscape/{z}/{x}/{y}.png',
	topoNaturalSuau:urlServerTiles+'/mapfactory/wmts/natural_suau/CAT3857/{z}/{x}/{y}.png',
	toponimsNaturalSuau:urlServerTiles+'/mapfactory/wmts/toponimia/CAT3857/{z}/{x}/{y}.png',

    //topoLimitsSuau:urlServerTiles+'/mapfactory/wmts/limits/CAT3857/{z}/{x}/{y}.png',
//https://geoserveis.icgc.cat/servei/catalunya/contextmaps/wmts/contextmaps-orto-estandard/MON3857NW/{z}/{x}/{y}.png
	topoLimitsSuau:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/administratiu/MON3857NW/{z}/{x}/{y}.png',

	fonsBlank:'/static/img/FFFFFF-0.png',
	hibridTotal2:urlServerTiles+'/mapfactory/wmts/hibrida_total/CAT3857/{z}/{x}/{y}.png',
	hibridTotal:'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/orto-hibrida/MON3857NW/{z}/{x}/{y}.png',
	topoEuroRegio: "https://mapcache.icgc.cat/map/euroregio/wmts/euroregio/MON3857NW/{z}/{x}/{y}.png",
	topoSuauColor:{
		zombie:{
			suau:urlServerTiles+'/mapfactory/wmts/coure_topo_suau/CAT3857/{z}/{x}/{y}.png',
			osm:urlServerTiles+'/mapfactory/wmts/coure_osm_suau/CAT3857_15/{z}/{x}/{y}.png'
		},
		nit:{
			suau:urlServerTiles+'/mapfactory/wmts/nit_topo_suau/CAT3857/{z}/{x}/{y}.png',
			osm:urlServerTilesW+'/mapfactory/wmts/nit_osm_suau/CAT3857_15/{z}/{x}/{y}.png'
		},
		orquidea:{
			suau:urlServerTiles+'/mapfactory/wmts/blueprint_topo_suau/CAT3857/{z}/{x}/{y}.png',
			osm:urlServerTiles+'/mapfactory/wmts/blueprint_osm_suau/CAT3857_15/{z}/{x}/{y}.png'
		},		  
		sepia:{
			suau:urlServerTiles+'/mapfactory/wmts/sepia_topo_suau/CAT3857/{z}/{x}/{y}.png',
			osm:urlServerTilesW+'/mapfactory/wmts/sepia_osm_suau/CAT3857_15/{z}/{x}/{y}.png'
		}
	},
	fonsGeologic: "https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/geologic/MON3857NW/{z}/{x}/{y}.png"
}

var FONSMAPA = {
	colorBlankMap: {
		typeMap: 'colorBlankMap',
		maxZoom: 22,
		layers: [
			{
				url: mapaUrl.fonsBlank,
				options: {
					minZoom: 2,
					maxZoom: 22,
					tms:false,
					continuousWorld: true,
					worldCopyJump:false,
					attribution: [ICGC],
					scope: SCOPE_TOT,
					zIndex: -1
				},
				type: 'tileLayer'
			}
		]
	},
	colorMap: {
		typeMap: 'colorMap',
		maxZoom: 22,
		layers: []
	},
	divadminMap: {
		typeMap: 'divadminMap',
		maxZoom: 18,
		layers: [
			{
				url: mapaUrl.topoLimitsSuau,
				options: {
					minZoom: 0,
					maxZoom: 13,
					tms:false,
					continuousWorld: true,
					worldCopyJump:false,
					attribution: [OSM_ATTR, ICGC],
					scope: SCOPE_TOT,
					zIndex: -3
				},
				type: 'tileLayer'
			}
			
			,{
				url: mapaUrl.topoLimitsSuau,
				options: {
					minZoom: 14,
					maxZoom: 18,
					tms:false,
					//color:'gris',
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.toponimsNaturalSuau,
				options: {
					minZoom: 0,
					maxZoom: 1,
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			}
			
		]
	},
	hibridMap: {
		typeMap: 'hibridMap',
		maxZoom: 19,
		backgroundColor: {
			[SCOPE_VISTA_FORA]: "#DDDDDD",
			[SCOPE_VISTA_DINS]: "#1B2C4A",
			[SCOPE_VISTA_TOT]: "#1B2C4A"
		},
		layers: [
			{
				url: mapaUrl.ortoEsri,
				options: {
					minZoom: 0,
					maxZoom:1,
					attribution: [ESRI_ATTR],
					scope: SCOPE_GLOBAL,
					zIndex: -5
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.ortoAugmentada,
				options: {
					tms:false,
					minZoom: 0,
					maxZoom: 1,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -4
				},
				printable: true,
				type: 'tileLayer'
			},
			{
				url: mapaUrl.ortoAugmentada,
				options: {
					tms:false,
					minZoom: 0,
					maxZoom: 1,
					boundary: catContorn5k,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -4
				},
				printable: false,
				type: 'boundaryCanvas'
			},
			{
				url: mapaUrl.ortoICGC,
				options: {
					tms:false,
					minZoom: 0,
					maxZoom: 1,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.hibridTotal,
				options: {
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					subdomains:subDomainsA,
					minZoom: 0,
					maxZoom: 18,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.toponimsNaturalSuau,
				options: {
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					opacity:0,
					minZoom: 0,
					maxZoom: 1,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			}
		]
	},
	hibridTerrainMap: {
		typeMap: 'hibridTerrainMap',
		maxZoom: 17,
		layers: [
			{
				url: mapaUrl.terrainEsri,
				options: {
					minZoom: 0,
					maxZoom:1,
					attribution: [ESRI_ATTR_TERRAIN],
					scope: SCOPE_GLOBAL,
					zIndex: -4
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.terrainInstamaps,
				options: {
					minZoom: 0,
					maxZoom: 1,
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.hibridTotal,
				options: {
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					subdomains:subDomainsA,
					minZoom: 0,
					maxZoom: 18,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.toponimsNaturalSuau,
				options: {
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					minZoom: 16,
					maxZoom: 18,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
		]
	},
	historicOrtoMap: {
		typeMap: 'historicOrtoMap',
		maxZoom: 17,
		layers: [
			{
				url: mapaUrl.orto55ICGC,
				options: {
					minZoom: 0,
					maxZoom: 17,
					tms:false,
					continuousWorld: true,
					worldCopyJump:false,
					attribution: [ICGC_HISTOOrto],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
		]
	},
	historicOrtoMap46: {
		typeMap: 'historicOrtoMap46',
		maxZoom: 17,
		layers: [
			{
				url: mapaUrl.orto46ICGC,
				options: {
					minZoom: 0,
					maxZoom: 17,
					tms:false,
					continuousWorld: true,
					worldCopyJump:false,
					attribution: [ICGC_HISTOOrto46],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
		]
	},
	naturalMap: {
		typeMap: 'naturalMap',
		maxZoom: 18,
		backgroundColor: {
			[SCOPE_VISTA_FORA]: "#DDDDDD",
			[SCOPE_VISTA_DINS]: "#CBDCDC",
			[SCOPE_VISTA_TOT]: "#DDDDDD"
		},
		layers: [
			{
				url: mapaUrl.topoMapSuauOSM,
				options: {
					minZoom: 0,
					maxZoom: 14,
					tms:false,
					continuousWorld: false,
					worldCopyJump: false,
					attribution: [OSM_ATTR,ICGC],
					scope: SCOPE_TOT,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoNaturalOSM,
				options: {
					minZoom: 15,
					maxZoom:18,
					subdomains:subDomainsA,
					attribution: [OSM_ATTR],
					scope: SCOPE_GLOBAL,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoNaturalSuau,
				options: {
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					subdomains:subDomainsA,
					minZoom: 8,
					maxZoom: 18,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.toponimsNaturalSuau,
				options: {
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					opacity:0.8,
					minZoom: 8,
					maxZoom: 18,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
		]
	},
	ortoMap: {
		typeMap: 'ortoMap',
		maxZoom: 20,
		layers: [
			{
				url: mapaUrl.ortoEsri,
				options: {
					minZoom: 0,
					maxZoom:19,
					attribution: [ESRI_ATTR],
					scope: SCOPE_GLOBAL,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.ortoInstamaps,
				options: {
					tms:false,
					minZoom: 0,
					maxZoom: 1,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.ortoICGC,
				options: {
					tms:false,
					minZoom: 6,
					maxZoom: 20,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			}
		]
	},
	terrainMap: {
		typeMap: 'terrainMap',
		maxZoom: 17,
		layers: [
			{
				url: mapaUrl.terrainEsri,
				options: {
					minZoom: 0,
					maxZoom:9,
					attribution: [ESRI_ATTR_TERRAIN],
					scope: SCOPE_GLOBAL,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.terrainInstamaps,
				options: {
					minZoom: 0,
					maxZoom: 17,
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				 },
				type: 'tileLayer'
			},
		]
	},
	topoGrisMap: {
		typeMap: 'topoGrisMap',
		maxZoom: 18,
		layers: [
			{
				url: mapaUrl.topoGrisOSM,
				options: {
					minZoom: 0,
					maxZoom:14,
					color:'gris',
					subdomains:subDomains,
					attribution: [OSM_ATTR,ICGC],
					scope: SCOPE_TOT,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoMapOSM,
				options: {
					minZoom: 15,
					maxZoom:18,
					color:'gris',
					subdomains:subDomains,
					attribution: [OSM_ATTR],
					scope: SCOPE_GLOBAL,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoGrisICGC,
				options: {
					tms:false,
					minZoom: 15,
					maxZoom: 18,
					continuousWorld: true,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
		]
	},
	topoEuroRegio: {
		typeMap: 'topoEuroRegio',
		maxZoom: 12,
		layers: [
			{
				url: mapaUrl.topoEuroRegio,
				options: {
					minZoom: 0,
					maxZoom: 12,
					tms:false,
					continuousWorld: false,
					worldCopyJump: false,
					attribution: [OSM_ATTR,ICGC],
					scope: SCOPE_TOT,
					zIndex: -1
				},
				type: 'tileLayer'
			}
		]
	},
	topoMap: {
		typeMap: 'topoMap',
		maxZoom: 20,
		backgroundColor: {
			[SCOPE_VISTA_FORA]: "#DDDDDD",
			[SCOPE_VISTA_DINS]: "#E0EAF3",
			[SCOPE_VISTA_TOT]: "#DDDDDD"
		},
		layers: [
			{
				url: mapaUrl.topoMapMON,
				options: {
					minZoom: 0,
					maxZoom: 6,
					tms:false,
					continuousWorld: false,
					subdomains:subDomainsA,
					worldCopyJump: false,
					attribution: [ICGC_MON],
					scope: SCOPE_GLOBAL,
					zIndex: -4
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoMapOSM,
				options: {
					minZoom: 7,
					maxZoom:19,
					subdomains:subDomains,
					attribution: [OSM_ATTR],
					scope: SCOPE_GLOBAL,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoMapICGC,
				options: {
					tms:false,
					minZoom: 13,
					maxZoom: 20,
					boundary: catContorn,					
					subdomains:subDomainsA,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -2
				},
				printable: true,
				type: 'boundaryCanvas'
			},
			{
				url: mapaUrl.topoMapICGC,
				options: {
					tms:false,
					minZoom: 13,
					maxZoom: 20,
					boundary: catContorn,				
					subdomains:subDomainsA,				
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -2
				},
				printable: false,
				type: 'boundaryCanvas' //'boundaryCanvas'
			},
			{
				url: mapaUrl.topoMapICGC,
				options: {
					tms:false,
					minZoom: 7,
					maxZoom: 12,
					continuousWorld: true,
					subdomains:subDomainsA,
					worldCopyJump: false,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			}
		]
	},
	topoMapGeo: {
		typeMap: 'topoMapGeo',
		maxZoom: 18,
		backgroundColor: {
			[SCOPE_VISTA_FORA]: "#DDDDDD",
			[SCOPE_VISTA_DINS]: "#CBDCDC",
			[SCOPE_VISTA_TOT]: "#CBDCDC"
		},
		layers: [
			{
				url: mapaUrl.topoMapSuauOSM,
				options: {
					minZoom: 1,
					maxZoom: 14,
					subdomains: subDomainsA,
					tms: false,
					continuousWorld: false,
					worldCopyJump: false,
					attribution: [OSM_ATTR,ICGC],
					scope: SCOPE_TOT,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoMapOSM,
				options: {
					minZoom: 15,
					maxZoom: 18,
					subdomains: subDomains,
					attribution: [OSM_ATTR],
					scope: SCOPE_GLOBAL,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoMapSuauICGC,
				options: {
					tms: false,
					continuousWorld: true,
					worldCopyJump: false,
					minZoom: 15,
					maxZoom: 18,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
		]
	},
	fonsGeologic :{
		typeMap: 'fonsGeologic',
		maxZoom: 14,
		layers: [
			{
				url: mapaUrl.fonsGeologic,
				options: {
					minZoom: 2,
					maxZoom: 14,
					tms:false,
					continuousWorld: false,
					worldCopyJump: false,
					attribution: [ONE_GEOLOGY,EMODNET,OSM_ATTR,ICGC],
					scope: SCOPE_TOT,
					zIndex: -1
				},
				type: 'tileLayer'
			}
		]
	}
};

L.IM_Map = L.Map.extend({

	options: {
		typeMap: FONSMAPA.topoMap.typeMap,
		mapColor: '',
		measureControl: true,
		preferCanvas: true
	},

	initialize: function(id,options) {
		L.Map.prototype.initialize.call(this,id,options);
		L.Util.setOptions(this, options);
		
		this.changeBackgroundType(options.typeMap);

		this.on('moveend', function(){
			this.gestionaFons(false);
			setTimeout(function () {
				var urlApp = document.location.href;
				var isVisor = (-1 != urlApp.indexOf('instavisor')) || (-1 != urlApp.indexOf('visor'));
				if (isVisor){
					if (markerLocation!==undefined && markerLocation!==null) map.panTo(markerLocation._latlng);	
				}
				else {
					if (markerLocationEditor!==undefined && markerLocationEditor!==null) map.panTo(markerLocationEditor._latlng);	
				}				
			
			}, 25000);
			
		});
	},

	changeBackgroundType: function(typeMap, print){
		var bckgrLayer = FONSMAPA[typeMap];
		var color = null;
		if (!bckgrLayer){
			if(typeMap === 'colorMap' || (typeMap.indexOf('colorBlankMap') !== -1)){
				color = typeMap.replace('colorBlankMap','');
				bckgrLayer = FONSMAPA['colorBlankMap'];
				bckgrLayer.typeMap = typeMap;
			}else if (Object.keys(mapaUrl.topoSuauColor).includes(typeMap)){
				bckgrLayer = FONSMAPA['colorMap'];
				bckgrLayer.layers = this.createColorMapBackgroundLayers(typeMap);
				bckgrLayer.typeMap = typeMap;
				if (typeMap === 'ortoMap') color='#152743';
			}
		}
		
		var newBackground = Background(bckgrLayer);
		
		this.setBackground(newBackground, color, print);

		try{
			this.gestionaVista();
			this.gestionaAttribution();
		}catch(error){
			//console.error(error);
		}		

	},

	//Funcio nova 3D
	getLGActiveMap:function(){
		return this.activeMap.layerGroup;
	},

	deletePreviousMap: function () {
		if(this.activeMap){
			this.removeLayer(this.activeMap.layerGroup);
		}
	},

	getActiveMap:function(){
		return this.options.typeMap;
	},

	getCurrentZoomLevel:function(){
		if(estatMapa3D){
			return "";
		}else{
			return " ZL:"+this.getZoom();
		}
	},
	
	setActiveMap:function(typeMap){
		this.options.typeMap = typeMap;
		//Activa mapa vista 3D
		if(estatMapa3D){
			mapaVista3D.addBaseLayersCesium();
		}
	},

	getMapColor:function(){
		return this.options.mapColor;
	},

	setMapColor:function(mapColor){
		this.options.mapColor = mapColor;
	},

	miraCentreDins:function(x,y){
		var x0=0.1087; //0.7525
		var y0=40.4763; // 40.5263
		var x1=3.33669; // 3.3563
		var y1=42.8855;  // 42.3748
		if(x>=x0&&x<=x1&&y>=y0&&y<=y1){return true;}else{return false;}
	},

	dinsCatalunya:function(MapBounds){


		var x = MapBounds.getWest(), y = MapBounds.getNorth();

	    var inside = false;
	    for (var i = 0, j = CatPol.length - 1; i < CatPol.length; j = i++) {
	        var xi = CatPol[i][0], yi = CatPol[i][1];
	        var xj = CatPol[j][0], yj = CatPol[j][1];

	        var intersect = ((yi > y) != (yj > y))
	            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
	        if (intersect) inside = !inside;
	    }

	    return inside;

	},

	miraBBContains:function(MapBounds){
		
		var boundsFixed = this.wrapLatLngBounds(MapBounds);
		var socCatalnunya=0;
		var vC=CatBounds.intersects(boundsFixed);// True es veu Cat
		var nC=CatBounds.contains(boundsFixed);//True nomes Cat
		   if(!vC){
				socCatalnunya=SCOPE_VISTA_FORA; //Estic fora de Cat
		   }else if(vC && !nC){ //veig Cat i altres
				//cas=1;
				this.dinsCatalunya(boundsFixed)? socCatalnunya=SCOPE_VISTA_DINS : socCatalnunya=SCOPE_VISTA_TOT
		   }else if (vC && nC){ //Nomes veig cat
				this.dinsCatalunya(boundsFixed) ? socCatalnunya=SCOPE_VISTA_DINS : socCatalnunya=SCOPE_VISTA_TOT;
		   }
		return socCatalnunya;
	},
	
	setTransActiveMap:function(trans,hillActiu){

	},
	
	gestionaVista: function(){
		//mirar si el zoom actual es mayor que el zoom maximo de la capa fondo actual
		this.ajustaZoom(this.activeMap.maxZoom);

		//mirar si la capa fondo actual es solo de catalunya (ej. historicas) hacer el this.fitBounds(CatBounds);
		var scope = this.activeMap.getVista();
		var viewCatalunya = CatBounds.intersects(this.getBounds());
		if(scope === SCOPE_CATALUNYA && !viewCatalunya){
			this.fitBounds(CatBounds);
		}
	},

	gestionaAttribution: function(){
		var self = this;
		var bkg_attr = this.activeMap.gestionaAttribution();
		if(this.attributionControl){
			this.attributionControl.text = bkg_attr;
		}else{
			this.attributionControl = {text:bkg_attr};
		}
		if(this.attributionControl.container){
			$(this.attributionControl.container).html(this.attributionControl.text);
		}
				
		//this.attributionControl.setPrefix(bkg_attr +this.getCurrentZoomLevel());
		/*
		for (layer in this.attributionControl._attributions) {
			self.attributionControl.removeAttribution(layer);
		}
		this.attributionControl.setPrefix(bkg_attr);
		*/
	},

	gestionaFons:function(layerAdd){
		var socCatalnunya=this.miraBBContains(this.getBounds());
		
		this.activeMap.gestionaBackground(socCatalnunya);
		
		this.gestionaAttribution();

		var color = this.activeMap.gestionaBackgroundColor(socCatalnunya);
		if (color){
			jQuery('#map').css('backgroundColor',color);
		}

		this.gestionaVista();
	},

	ajustaZoom:function (maxZoom){
		this.options.maxZoom=maxZoom;
		this.getZoom() > maxZoom ?  this.setZoom(maxZoom) : null;
	},

	rmCapa: function (grup,layer){
		if(grup.hasLayer(layer)){grup.removeLayer(layer);return}
	},

	addCapa: function (grup,layer){
		if(!grup.hasLayer(layer)){grup.addLayer(layer,true);return}
	},

	setBackground: function(newBackground, color, forPrint){
		this.deletePreviousMap();
		this.setMapColor(color);
		this.activeMap = newBackground;
		this.options.typeMap = newBackground.typeMap;
		this.ajustaZoom(newBackground.maxZoom);
		this.addLayer(newBackground.createBackground(forPrint),true);
		this.setActiveMap(newBackground.typeMap);
		if (color) {
			jQuery('#map').css('backgroundColor',color);
		}
	},
	
	createColorMapBackgroundLayers: function(color){
		return [
			{
				url: mapaUrl.topoSuauColor[color].osm,
				options: {
					minZoom: 0,
					maxZoom: 14,
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					color:color,
					attribution: [OSM_ATTR,ICGC],
					scope: SCOPE_TOT,
					zIndex: -3
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoMapOSM,
				options: {
					minZoom: 15,
					maxZoom:18,
					color:color,
					subdomains:subDomains,
					attribution: [OSM_ATTR],
					scope: SCOPE_GLOBAL,
					zIndex: -2
				},
				type: 'tileLayer'
			},
			{
				url: mapaUrl.topoSuauColor[color].suau,
				options: {
					minZoom: 15,
					maxZoom: 18,
					tms:false,
					continuousWorld: true,
					worldCopyJump: false,
					color:color,
					attribution: [ICGC],
					scope: SCOPE_CATALUNYA,
					zIndex: -1
				},
				type: 'tileLayer'
			},
		];
	}

});
